(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["geo-region-modal"] && !Shopify.designMode) return;
  try {
    /**
   * Offers the sibling GLIX storefront once, to the visitors it is meant for.
   * A dismissal is remembered for 30 days.
   */
  class GeoRegionModal extends HTMLElement {
    connectedCallback() {
      const dialog = this.querySelector('dialog');
      const mode = this.dataset.mode;
      const target = (this.dataset.target || '').replace(/\/+$/, '');
      if (!dialog || !target) return;

      const turkishLanguage = document.documentElement.lang === 'tr';
      const turkishTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone === 'Europe/Istanbul';

      let cookieName = 'store_intl_redirect_dismissed';
      if (mode === 'to_turkey') {
        if (!turkishLanguage && !turkishTimeZone) return;
        cookieName = turkishLanguage ? 'store_lang_redirect_dismissed' : 'store_region_dismissed';
      } else if (turkishTimeZone && turkishLanguage) {
        return;
      }

      if (document.cookie.includes(cookieName)) return;

      // Land on the same page of the other store. The stores publish different
      // languages (/tr here is the root there), so the language prefix is dropped:
      // the other store then redirects a translated handle to its own.
      const link = this.querySelector('[data-geo-go]');
      if (link instanceof HTMLAnchorElement) {
        const root = (this.dataset.root || '').replace(/\/+$/, '');
        let path = window.location.pathname;
        if (root && (path === root || path.startsWith(`${root}/`))) path = path.slice(root.length);

        // Variant ids belong to this store.
        const params = new URLSearchParams(window.location.search);
        params.delete('variant');
        const query = params.toString();

        link.href = target + (path || '/') + (query ? `?${query}` : '');
      }

      const dismiss = () => {
        document.cookie = `${cookieName}=1; path=/; max-age=2592000; SameSite=Lax`;
      };

      for (const button of this.querySelectorAll('[data-geo-stay]')) {
        button.addEventListener('click', () => dialog.close());
      }
      dialog.addEventListener('close', dismiss);
      dialog.showModal();
    }
  }

  if (!customElements.get('geo-region-modal')) {
    customElements.define('geo-region-modal', GeoRegionModal);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["localization-form"] && !Shopify.designMode) return;
  try {
    /**
   * The stand-alone language switcher. Entries are submit buttons of the
   * localization form, so this only opens, places and closes the list.
   */
  class LanguageMenu extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('.language-menu__toggle');
      this.list = this.querySelector('.language-menu__list');
      if (!this.toggle || !this.list) return;

      this.toggle.addEventListener('click', () => this.setOpen(this.list.hidden));
      this.addEventListener('keydown', (event) => this.onKeydown(event));
      this.addEventListener('focusout', (event) => {
        if (event.relatedTarget instanceof Node && !this.contains(event.relatedTarget)) this.setOpen(false);
      });
      this.onOutsideClick = (event) => {
        if (event.target instanceof Node && !this.contains(event.target)) this.setOpen(false);
      };

      // Choosing the language already shown has nothing to submit.
      this.list.querySelector('[aria-current="true"]')?.addEventListener('click', (event) => {
        event.preventDefault();
        this.setOpen(false);
      });
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onOutsideClick);
    }

    get items() {
      return Array.from(this.list.querySelectorAll('.language-menu__item'));
    }

    setOpen(open) {
      this.list.hidden = !open;
      this.toggle.setAttribute('aria-expanded', String(open));

      if (!open) {
        document.removeEventListener('click', this.onOutsideClick);
        return;
      }

      // Open towards whichever side has room: up in the footer, down in the header.
      const toggle = this.toggle.getBoundingClientRect();
      const { width, height } = this.list.getBoundingClientRect();
      this.dataset.block = toggle.bottom + height + 12 > window.innerHeight && toggle.top > height + 12 ? 'up' : 'down';
      this.dataset.inline = toggle.right - width < 8 ? 'start' : 'end';
      document.addEventListener('click', this.onOutsideClick);
    }

    onKeydown(event) {
      if (event.key === 'Escape' && !this.list.hidden) {
        event.stopPropagation();
        this.setOpen(false);
        this.toggle.focus();
        return;
      }

      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;

      event.preventDefault();
      if (this.list.hidden) this.setOpen(true);

      const items = this.items;
      const step = event.key === 'ArrowDown' ? 1 : -1;
      const index = items.indexOf(/** @type {HTMLButtonElement} */ (document.activeElement));
      const next = index < 0 ? (step > 0 ? 0 : items.length - 1) : (index + step + items.length) % items.length;
      items[next]?.focus();
    }
  }

  if (!customElements.get('language-menu')) {
    customElements.define('language-menu', LanguageMenu);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["policy-page"] && !Shopify.designMode) return;
  try {
    /**
   * Gives the policy's headings the ids its contents list links to. Shopify
   * prints the policy body, so the ids cannot be set in Liquid.
   */
  class PolicyPage extends HTMLElement {
    connectedCallback() {
      const body = this.parentElement?.querySelector('.shopify-policy__body');
      if (!body) return;

      body.querySelectorAll(this.dataset.heading || 'h2').forEach((heading, index) => {
        heading.id = `policy-section-${index + 1}`;
      });

      // The page loaded before the ids existed, so follow the link now.
      if (window.location.hash.startsWith('#policy-section-')) {
        document.getElementById(window.location.hash.slice(1))?.scrollIntoView();
      }
    }
  }

  if (!customElements.get('policy-page')) {
    customElements.define('policy-page', PolicyPage);
  }
  } catch(e) { console.error(e); }
})();

})();
